export default "__VITE_ASSET__D_r0rDA8__"